module.exports = __webpack_public_path__ + "img/2024-07-01a_5.8286c320.jpg";